import React, { FC, useState } from "react";
import {
  EuiButtonEmpty,
  EuiFlexGroup,
  EuiFlexItem,
  EuiLink,
  EuiSpacer,
} from "@elastic/eui";
import ProductGroupServicePanel from "components/products/ProductGroupServicePanel";

export interface IProductGroupClientFacingServicesEditorProps {
  services: string[];
  onAddService: () => void;
  onEditServiceText: (index: number, text: string) => void;
  onMoveServiceUp: (index: number) => void;
  onMoveServiceDown: (index: number) => void;
  onRemoveService: (index: number) => void;
}

const ProductGroupServicesEditor: FC<
  IProductGroupClientFacingServicesEditorProps
> = ({
  services,
  onAddService,
  onEditServiceText,
  onMoveServiceUp,
  onMoveServiceDown,
  onRemoveService,
}) => {
  const [showProductGroupServices, setShowProductGroupServices] =
    useState(true);

  const onAddServiceClicked = () => {
    setShowProductGroupServices(true);
    onAddService();
  };

  return (
    <>
      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiButtonEmpty iconType={"plus"} onClick={onAddServiceClicked}>
            Add Service
          </EuiButtonEmpty>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiButtonEmpty
            onClick={() =>
              setShowProductGroupServices(!showProductGroupServices)
            }
          >
            {showProductGroupServices ? "Hide" : "Show"} Services (
            {services.length})
          </EuiButtonEmpty>
        </EuiFlexItem>
      </EuiFlexGroup>

      {showProductGroupServices && (
        <>
          <EuiSpacer size={"xs"} />

          {services.map((service, index) => (
            <>
              <ProductGroupServicePanel
                key={index}
                service={{ index, text: service }}
                onEditServiceText={onEditServiceText}
                onMoveServiceUp={onMoveServiceUp}
                onMoveServiceDown={onMoveServiceDown}
                onRemoveService={onRemoveService}
              />

              <EuiSpacer size={"m"} />
            </>
          ))}
        </>
      )}
    </>
  );
};

export default ProductGroupServicesEditor;
